import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { bellevilleConfig } from "./data";

export default function BellevillePage() {
  return <CityPageTemplate config={bellevilleConfig} />;
}